/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Material UI
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';

// Styles
import useStyles from './chartSkeleton.styles';

interface ChartSkeletonInterface {
  showLegend?: boolean;
  customClasses?: {
    root?: string;
    skeleton?: string;
  };
}

type Props = ChartSkeletonInterface;

const ChartSkeleton: React.FC<Props> = ({ showLegend, customClasses }) => {
  const classes = useStyles();

  return (
    <Grid container direction='column' className={customClasses?.root || ''}>
      <Skeleton
        component='div'
        animation='pulse'
        className={[classes.chart, customClasses?.skeleton].join(' ')}
      />

      {showLegend && (
        <Grid container alignItems='center' wrap='nowrap'>
          <Grid item lg={4} md={4} sm={4} xl={4} xs={4}>
            <Grid container alignItems='center' wrap='nowrap'>
              <Skeleton
                animation='pulse'
                variant='rect'
                className={classes.square}
              />

              <Skeleton variant='text' className={classes.text} />
            </Grid>
          </Grid>

          <Grid
            item
            lg={8}
            md={8}
            sm={8}
            xl={8}
            xs={8}
            className={classes.text}>
            <Grid container alignItems='center' wrap='nowrap'>
              <Skeleton
                animation='pulse'
                variant='rect'
                className={classes.square}
              />

              <Skeleton variant='text' className={classes.text} />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default ChartSkeleton;
export { ChartSkeleton };
